import { useState, useEffect } from "react";

// Presentational client-side pager: shows the first `pageSize` items and grows
// on "load more". Resets whenever the (memoized) items reference changes — e.g.
// a new fetch or a filter change — so the list returns to page 1.
export function usePaged(items, pageSize = 50) {
  const [shown, setShown] = useState(pageSize);
  useEffect(() => { setShown(pageSize); }, [items, pageSize]);
  const visible = items.slice(0, shown);
  const hasMore = items.length > shown;
  const more = () => setShown((s) => s + pageSize);
  return { visible, hasMore, more, shownCount: Math.min(shown, items.length), total: items.length };
}
